import { ReactNode } from "react";
import Button, { ButtonProps } from "react-bootstrap/Button";

const SecondaryButton = (props: {children: ReactNode, rest?: ButtonProps}) => {
  return (
    <Button variant="outline-secondary" bsPrefix="btn-default bg-green-light" {...props.rest}>
        {props.children}
    </Button >
  )
}

export default SecondaryButton;